export default __webpack_public_path__ + "static/qualys-422b9773ba08e604c6356be45e9678b3.png";